import { EuiIcon } from "@elastic/eui";
import React, { useMemo } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { toDecimalString } from "../../../../../shared/utils/numbers";
import '../styles.css';

export const PieChartPanel = (props) => {

    const {data,showTotal,showCustomLabel, customToolTip, colors} = props;
      
    const COLORS = colors;
    const RADIAN = Math.PI / 180;

    const customLabel = (propsChart) => {
        const { cx, cy, midAngle, innerRadius, outerRadius, percent, index, value } = propsChart
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        
        return (
            <text x={x} y={y} fill="#ffffff" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${toDecimalString(value)}`}
            </text>
        );
    };

    const customLabelTotal = (propsChart) => {
      const { cx, x, y, fill, value } = propsChart;
      
      return (
          <text x={x} y={y} fill={fill} textAnchor={x > cx ? 'start' : 'end'}>
            {`${toDecimalString(value)}`}
          </text>
      );
  };

  const renderLegend = (props) => {
    const { payload } = props;
    
    return (
      <ul className='customLegendPieChart'>
        {
          payload.map((entry, index) => (
            <li key={`item-${index}`}><EuiIcon type='stopFilled' style={{color:entry.color}}/>{entry.value}</li>
          ))
        }
      </ul>
    )
  }

    const getTotalData = useMemo(()=>{
      let total = 0;
      if(showTotal){
        data.forEach((d)=> total+=d.value);
        return (<Pie
            data={[{name:'Total',value:total}]}
            cx="50%"
            cy="50%"
            labelLine={true}
            label={customLabelTotal}
            outerRadius={200}
            fill="#855AFF"
            dataKey="value"
            isAnimationActive = {false}
          ></Pie>)
      }else{return null}
    },[data,showTotal])
      
    return data && data.length>0 ? (
       <ResponsiveContainer width="100%" height="100%" style={{overflow:'auto'}}>
         <PieChart width={600} height={600}>
         {getTotalData}
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label= {customLabel}//{showCustomLabel ? customLabel : true}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
            isAnimationActive = {false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend layout='radial' height={'100%'} content={renderLegend}/>
          <Tooltip content={customToolTip}/>
        </PieChart>
        </ResponsiveContainer>
      ) : null
}